import module from '../settings.module';

module.factory('SettingsService', [
  '$resource',
  function ($resource) {
    var SettingsResource = $resource('/api/settings');

    return {
      get settings() {
        return SettingsResource.query().$promise;
      },
    };
  },
]);
